import angular from "angular";
import resolve from "ioc/resolve";
import templateUrl from "webmodals/busy.htm";
import open from "webmodals/open";

export default (title, message, size) =>
  open({
    backdrop: "static",
    templateUrl,
    size,
    scope: angular.extend(resolve("$rootScope").$new(), { title, message }),
  });
